<div admin-nav-menu *ngIf="isLoggedIn()"></div>

<div *ngIf="messages().length > 0" admin-msg-banner class="container-fluid mt-3"></div>
